<template>
<div>
    <!-- 标题组件 -->
    <el-card :class="[!isShowCard ? 'hidden_card' : '']">
        <el-form :label-width="params.labelWidth || '135px'" size="small" class="yl_form" :model="options" :rules="rules" ref='fomTemplete' >
            <el-row class="yl-title-sub">{{ title }}</el-row>
            <el-row :class="['yl-lc-form', {'yl-lc-width': isSingleFormCenter && rowClass === 'yl-singleForm'}]" v-if="params && params.parmas">
                <div v-for="(item,index) in params.parmas" :key="index">
                    <el-col :span="spanList[rowClass]"  v-if="buildComponentIsShow(item)">
                        <el-form-item :label="item.title" align="left" :prop="item.prop">
                                <span slot="label" v-if="item.tooltip" class="form_icon_tooltip">{{item.title.slice(0,7)}}
                                    <el-tooltip :content="item.tooltip" placement="top">
                                        <svg t="1639143822953" class="icon el_icon_tooltip" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5314" width="200" height="200">
                                            <path d="M512 960c-243.2 0-448-198.4-448-448 0-243.2 198.4-448 448-448 243.2 0 448 198.4 448 448s-204.8 448-448 448zM512 128C300.8 128 128 300.8 128 512s172.8 384 384 384 384-172.8 384-384-172.8-384-384-384z" p-id="5315"></path>
                                            <path d="M460.8 307.2c0 25.6 19.2 51.2 51.2 51.2s51.2-19.2 51.2-51.2S537.6 256 512 256s-51.2 19.2-51.2 51.2zM512 768c-19.2 0-32-12.8-32-32V448c0-19.2 12.8-32 32-32s32 12.8 32 32v288c0 19.2-12.8 32-32 32z" p-id="5316"></path>
                                        </svg>
                                    </el-tooltip>
                                </span>
                                <template v-if="!item.tooltip && item.title.length > 8">
                                    <span slot="label">
                                        <el-tooltip :content="item.title" placement="top">
                                            <span>{{item.title}}</span>
                                        </el-tooltip>
                                    </span>
                                </template>
                                <el-input v-if="item.type=='text'" v-model="options[item.prop]" :placeholder="item.placeholder" v-bind="item.formAttr" @change="item.changeCallback && item.changeCallback(options[item.prop])"></el-input>
                                <el-input v-if="item.type=='textarea'" type="textarea" v-model="options[item.prop]" autosize :placeholder="item.placeholder" show-word-limit v-bind="item.formAttr" @change="item.changeCallback && item.changeCallback(options[item.prop])"></el-input>
                                <el-select 
                                    v-if="item.type=='select'" 
                                    v-model="options[item.prop]" 
                                    :placeholder="item.placeholder" 
                                    :class="{'select_maxwidth': params.parmas.length > 2}"
                                    v-bind="item.formAttr" 
                                    @focus="getAsyncAPI(item)"
                                    :multiple="item.multiple || false"
                                    @change="item.changeCallback && item.changeCallback(options[item.prop])" 
                                    :remote="item.formAttr.remote" 
                                    :remote-method="(query) => remoteMethod(query, item)">
                                        <el-option 
                                            v-for="childItem in item.data" 
                                            :key="childItem[item.key]" 
                                            :label="childItem['name'] || childItem[item['label']]" 
                                            :value="childItem['code']"
                                        >
                                        </el-option>
                                </el-select>
                                <el-date-picker v-if="item.type=='date'" v-model="options[item.prop]" type="date" :placeholder="item.placeholder" :value-format="item.valueFormat || 'timestamp'" :picker-options="item.pickerOptions"></el-date-picker>
                                <el-date-picker v-if="item.type=='daterange'" unlink-panels v-model="options[item.prop]" type="daterange" :default-time="['00:00:00','23:59:59']" 
                                    :value-format="item.valueFormat || 'timestamp'" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="item.pickerOptions" @change="updateDaterangeProp(item)"></el-date-picker>
                                <el-cascader
                                    v-if="item.type=='cascader'"
                                    v-model="options[item.prop]"
                                    v-bind="item.formAttr"
                                    :options="item.data"
                                    @change="item.changeCallback && item.changeCallback(options[item.prop])" 
                                ></el-cascader>
                                <el-switch v-if="item.type=='switch'" v-model="options[item.prop]" ></el-switch>
                                <template v-if="item.formAttr['isButton']">
                                    <el-checkbox-group v-if="item.type=='checkbox'" v-model="options[item.prop]" >
                                        <el-checkbox-button v-for="childItem in item.data" :key="childItem['code'] || childItem" :label="childItem['name'] || childItem" :checked="childItem['checked']" v-bind="item.formAttr" name="type">{{childItem['name'] || childItem}}</el-checkbox-button>
                                    </el-checkbox-group>
                                </template>
                                <template v-else>
                                    <el-checkbox-group v-if="item.type=='checkbox'" v-model="options[item.prop]">
                                        <el-checkbox v-for="childItem in item.data" :key="childItem['code'] || childItem" :label="childItem['code'] || childItem" :checked="childItem['checked']" v-bind="item.formAttr" name="type">{{childItem['name'] || childItem}}</el-checkbox>
                                    </el-checkbox-group>
                                </template>
                                <el-radio-group v-if="item.type=='radio'" v-model="options[item.prop]">
                                    <el-radio v-for="childItem in item.data" :key="childItem['code'] || childItem" :label="childItem['code'] || childItem" v-bind="item.formAttr">{{childItem['name'] || childItem}}</el-radio>
                                </el-radio-group>
                            </el-form-item>
                    </el-col>
                </div>
            </el-row>
        </el-form>
        <div class="text-center" v-if="isShowButton">
            <!-- <slot></slot> -->
            <template v-for="(item,index) in formButtonList.buttonList">
                <yl-lc-button 
                    v-if="show(item) && item.on && item.on.find(child=>child.name=='click')"
                    :ref="`button${index}`"
                    :type="item.type" 
                    :plain="item.plain" 
                    :icon="item.icon" 
                    :name="item.name" 
                    :key="index"
                    :data="item"
                    :disabled="isDisabled(item) && item.on && item.on.some(child=>child.name=='click')"
                    @click.native="clickScript(item)"
                >
                </yl-lc-button>
            </template>
        </div>
    </el-card>
</div>

</template>

<script>
import build from '../../../lib/build.js';
import utils from '../../../lib/main.js';
import mixin from "./mixin"
export default {
    name:"yl-lc-form",
    mixins:[mixin],
    props: {
        title: {
            type:String,
            default: '单列表单'
        },
        rowClass: {
            type: String,
            default: 'yl-singleForm'
        },
        searchParmas:{
            type:[Object,Array],
            default:null
        },
        load:{
            type:Boolean,
            default:true
        },
        isCard:{
            type:[Boolean],
            default: true
        },
        searchIsDisabled:{
            type:[Boolean],
            default: false
        },
        // 表格组件ref
        tableRefs:{
            type:Object,
            default:null
        },
        // 表格组件ref名称
        tableRefsName:{
            type:String,
            default:null
        },
        beforeSearch: Function,
        beforeSubmit: Function,
        isShowButton: {
            type: Boolean,
            defalut: true
        },
        isShowCard: {
            type: Boolean,
            defalut: true
        },
        isSingleFormCenter: {
            type: Boolean,
            defalut: false
        },
        formButton:{
            type:Object,
        }
    },
    data() {
        return {
            searchToggle:{
                state:true,
                text:"展开",
                icon:"el-icon-arrow-down"
            },
            PageSize: 20,
            searchCopyParmas: null,
            params:[],
            indorserUserBankList: [],
            formTypeList: { 'yl-singleForm': '单列表单', 'yl-doubleForm': '双列表单', 'yl-threeForm' : '三列表单'},
            spanList: { 'yl-singleForm': 24, 'yl-doubleForm': 12, 'yl-threeForm' : 8},
            rules:{},
            fetchApi:{},
            options:null,
            formButtonList: {
                buttonList:[]
            },
        }
    },
    watch: {
        "searchParmas":{
            handler(data){
                this.options = data.request.options;
                data.parmas.forEach((item,index) => {
                    this.rules = Object.assign(this.rules,{
                        [item.prop]: build.transRules(item.regList)
                    })
                    if(item.type == 'checkbox'){
                        this.$set(this.options,item.prop,[])
                    }
                    if(item.type == 'radio'){
                        item.data && item.data.forEach(val => {
                            if(val.checked){
                                this.$set(this.options,item.prop,val['code'])
                            }
                        })
                    }
                })
                this.params = data;
            },
            immediate:true
        },
        "formButton": {
            handler(val) {
                if(val !== undefined){
                    if(!val.hasOwnProperty('buttonList')){
                        this.$set(val,'buttonList',[])
                    }
                    val.buttonList.forEach(item => {
                        if(!item.isDisabled){
                            item.isDisabled = {
                                isAction:true,
                                body:"",
                                status: false
                            }
                        }
                    });
                    Object.assign(this.formButtonList,val);
                }
            },
            immediate: true
        }
    },
    mounted(){
        this.searchCopyParmas = JSON.parse(JSON.stringify(this.searchParmas))
        this.params.parmas.forEach((item,index) => {
            if(item.__on__ && item.__on__.length>0){
                item.changeCallback = utils.executeEvent(item.__on__[0]);
            }
            if(item.dataSource.body){
                let sourceData = this.resolveSource(item.dataSource.body);
                if(sourceData.run){
                    sourceData.run('',item).then(res=>{
                        item.data = res.data.data;
                    })
                }else{
                    item.data = sourceData;
                }
            }
        })
    },
    methods: {
        setName(index,propValue){
            this.$refs[`button${index}`][0].label = propValue;
        },
        show(item){
            if(item.isShow.isAction){
                return item.isShow.status;
            }
            if(!item.isShow.isAction){
                if(window.LOWCODE.source){
                    return this.$lowcode.execute(item.isShow.body);
                }
                if(!window.LOWCODE.source){
                    return this.$store.getters.getPageObject(item.isShow.body);
                }
            }
        },
        isDisabled(item){
            if(item.isDisabled.isAction){
                return item.isDisabled.status;
            }
            if(!item.isDisabled.isAction){
                if(window.LOWCODE.source){
                    return this.$lowcode.execute(item.isDisabled.body);
                }
                if(!window.LOWCODE.source){
                    return this.$store.getters.getPageObject(item.isDisabled.body);
                }
            }
        },
        clickScript(data){
            let disabled = this.isDisabled(data) && data.on && data.on.some(child=>child.name=='click')
            if(!disabled){
                let eventObj = data.__on__ && data.__on__.length>0 ? data.__on__[0] : null;
                if(eventObj && window.LOWCODE.source){
                    this.$lowcode.executeEvent(eventObj)();
                }
                if(eventObj && !window.LOWCODE.source){
                    this.$store.getters.exeMethods(eventObj);
                }
            }
        },
        // 重置
        reset(){
            for (let data in this.params.request.options) {
                this.$set(this.params.request.options, data, this.searchCopyParmas.request.options[data])
            }
            this.$emit("reset", this.params.request.options)
        },
        validate(){
            let flag = null;
            this.$refs.fomTemplete.validate((valid)=>{
                flag = valid
            })
            return flag
        },
        buildComponentIsShow(row){
            return !row.isShow.isAction ? this.resolveSource(row.isShow.body) : row.isShow.status;
        },
        getAsyncAPI(source){
            let data = source.dataSource.body;
            if(data){
                this.fetchApi.API = this.resolveSource(data);
            }
        },
        remoteMethod(query,item){
            if(this.fetchApi.API){
                let API = this.fetchApi.API;
                if(API){
                    Object.keys(API.params).map(key=>{
                        API.params[key] = this.resolveSource(API.params[key])
                    });
                    API.run(query,item).then(res=>{
                        item.data = res.data.data;
                    })
                }
            }
        },
        updateDaterangeProp(data){
            let vals = this.params.request.options[data.prop]
            this.params.request.options[data.propStart] = vals[0];
            this.params.request.options[data.propEnd] = vals[1];
        },
        setOption(index,field,data){
            this.$set(this.params.parmas[index],field,data);
        }
	}
}
</script>
<style lang="less" scoped>
.yl-lc-form {
    margin: 0 auto;
}
.yl-lc-width {
    width: 50%;
}
.el-select{
    max-width: 480px;
}
</style>